// extracted by mini-css-extract-plugin
export default {"container":"g75QiC","content":"_1gvRpQ"};